import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=65d59982&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=65d59982&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d59982",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d59982')) {
      api.createRecord('65d59982', component.options)
    } else {
      api.reload('65d59982', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=65d59982&scoped=true", function () {
      api.rerender('65d59982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Feedback.vue"
export default component.exports